import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { SidebarProvider } from './components/SidebarContext'; // ✅ Added this line

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SidebarProvider> {/* ✅ Wrapped App */}
      <App />
    </SidebarProvider>
  </React.StrictMode>
);

reportWebVitals();
